module.exports = __webpack_public_path__ + "img/9.7be7dcc4.jpg";